const Config = {
  StackName: "prod-doc-analyzer",
  DefaultImageName: "default_document_3.png",
  CognitoIdentityPoolId: "us-east-1:8480e3e7-78d9-4c6f-90f0-9bcc4e433db8",
  CognitoUserPoolId: "us-east-1_bKsXntMzg",
  DeployRegion: "us-east-1",
  CognitoId: "cognito-idp.us-east-1.amazonaws.com/us-east-1_bKsXntMzg",
  APIUrl: "https://v40m6m4vm5.execute-api.us-east-1.amazonaws.com/prod",
  LogoutUrl:
    "https://uat-aarp-platform.auth.us-east-1.amazoncognito.com/logout?client_id=45vmdldlpkf3lu5bvf5urmqig1&logout_uri=https://portal.uat.aarp.us.spsglobal.com&redirect_uri=https://portal.uat.aarp.us.spsglobal.com&response_type=token",
  LoginUrl:
    "https://uat-aarp-platform.auth.us-east-1.amazoncognito.com/login?client_id=45vmdldlpkf3lu5bvf5urmqig1&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://portal.uat.aarp.us.spsglobal.com",
  ChatExternalLink: "https://www.google.com",
  TicketExternalLink: null,
  AnalyticsExternalLink: "https://reports.uat.aarp.us.spsglobal.com/",
  TicketTableColumns: {
    ticket: { visible: true },
    title: { visible: true },
    subject: { visible: true },
    status: { visible: true },
    docClass: { visible: true },
    lob: { visible: true },
    created: { visible: true },
    checkNumber: { visible: false, hideIfEmpty: true },
    checkType: { visible: false, hideIfEmpty: true },
    checkAmount: { visible: false, hideIfEmpty: true },
    comments: { visible: true },
    view: { visible: true },
    action: { visible: true },
  },
};

export default Config;
